import { StyledButton } from '@/components/styled/button';
import { Box, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { useState } from 'react';
import generatePDF from 'react-to-pdf';

interface Props {
  design: any;
  targetRef: any;
  setLoading: any;
  submissionId?: string;
  showHeading?: boolean;
  text: string;
  bottomBorder?: boolean;
  headerSize?: number;
  subHeader?: string;
}

export const ShareResults: React.FC<Props> = ({
  design,
  submissionId,
  targetRef,
  setLoading,
  showHeading,
  text,
  bottomBorder = true,
  headerSize = 19,
  subHeader,
}) => {
  const [showShareUrlToast, setShowShareUrlToast] = useState(false);

  const copyResultsUrl = (): void => {
    let shareUrl: string = window.location.href;
    if (submissionId) {
      shareUrl += `/submission/${submissionId}`;
    }
    navigator.clipboard.writeText(shareUrl);
    setShowShareUrlToast(true);
  };

  const handleCloseToast = (): void => {
    setShowShareUrlToast(false);
  };

  const handleGeneratePDF = async () => {
    setLoading(true);
    await generatePDF(targetRef, {
      filename: 'Design-skill-stack.pdf',
    });
    setLoading(false);
  };

  return (
    <Box
      sx={{
        marginBottom: '24px',
        marginTop: '50px',
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showShareUrlToast}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        message='Your Design Skill Stack URL has been copied to the clipboard'
        ContentProps={{
          sx: {
            border: '1px solid #fff',
            color: '#fff',
            fontWeight: 'bold',
            textAlign: 'center',
          },
        }}
      />
      {showHeading && (
        <Typography
          sx={{
            fontSize: `${headerSize}px`,
            fontWeight: '700',
            color: '#fff',
            textAlign: 'center',
            marginTop: '24px',
          }}
        >
          {text}
        </Typography>
      )}
      {subHeader && (
        <Typography
          sx={{
            fontSize: `17px`,
            fontWeight: '700',
            color: '#fff',
            textAlign: 'center',
            marginTop: '24px',
          }}
        >
          {subHeader}
        </Typography>
      )}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '10px',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: bottomBorder ? '1px solid #444' : null,
          paddingBottom: bottomBorder ? '20px' : null,
        }}
      >
        <StyledButton
          background='#fff'
          $buttonColor={'#000'}
          highlight={design.colors.buttonActive}
          type='submit'
          className={'continue-button'}
          onClick={() => copyResultsUrl()}
          style={{
            marginTop: '40px',
            width: '172px',
            marginRight: '10px',
            fontWeight: '700',
          }}
        >
          {'COPY URL'}
        </StyledButton>
        <StyledButton
          background='#fff'
          $buttonColor={'#000'}
          highlight={design.colors.buttonActive}
          type='submit'
          className={'continue-button'}
          onClick={() => handleGeneratePDF()}
          style={{ marginTop: '40px', width: '172px', fontWeight: '700' }}
        >
          {'EXPORT PDF'}
        </StyledButton>
      </Box>
    </Box>
  );
};
